import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TransitionReport } from '@isophi/teachers-shared';
import { TransitionReportContract, TransitionReportUpdateContract } from '@isophi/teachers-shared';
import { map, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TransitionReportService {
  private readonly httpClient = inject(HttpClient);

  private readonly baseUrl = `${environment.teacherAPI}/transition-reports`;

  public getReport(childUuid: string): Observable<TransitionReport> {
    const url = `${this.baseUrl}/${childUuid}/`;
    return this.httpClient.get<TransitionReportContract>(url).pipe(
      map((response) => {
        return TransitionReport.deserialize(response);
      })
    );
  }

  public updateReport(childUuid: string, reportData: TransitionReportUpdateContract): Observable<TransitionReport> {
    const url = `${this.baseUrl}/${childUuid}/`;
    return this.httpClient.put<TransitionReportContract>(url, reportData).pipe(
      map((response) => {
        return TransitionReport.deserialize(response);
      })
    );
  }
}
